module.exports = __webpack_public_path__ + "static/media/map-vietnam-011.12a8ca13.png";